module.exports = __webpack_public_path__ + "img/plant_1_small.24f2f95c.webp";